import {Injectable} from '@angular/core';
import {Cirf} from '../cirf/cirf';
import {Observable} from 'rxjs';
import {connectApi} from '../common/connect-api';
import {map} from 'rxjs/internal/operators';
import {Referral} from './referral';
import {HttpClient} from '@angular/common/http';
import {SESSION_STORAGE_KEYS} from '../common/session-storage-keys';
import {UnityConnectTransaction} from '../common/model/unity-connect-transaction';
import {MatterInfo} from '../common/matter-info';
import {CustomHttpParams} from '../common/connect-http-interceptor';

@Injectable({
    providedIn: 'root'
})
export class ReferralService{

    constructor(private  httpClient: HttpClient) {
    }

    getReferralTransactionsForCurrentUser(): Observable<UnityConnectTransaction[]> {
        return this.httpClient
            .get(connectApi.getReferralsForCurrentUser, {
                params: new CustomHttpParams(true)
            })
            .pipe(map(res => res['Referrals']));
    }

    getReferralMatterInfo(referralId: string): Observable<MatterInfo> {
        return this.httpClient
            .get<MatterInfo>(`${connectApi.getReferralMatterInfo.replace('{referralId}', referralId)}`)
            .pipe(map(result => new MatterInfo(result['MatterInfo'])));
    }

    getReferralLogoFirm(id: string, fileId: number): string {
        return connectApi.getReferralFirmLogo
            .replace('{referralId}', id)
            .replace('{fileId}', fileId.toString())
            .replace('{sessionId}', sessionStorage.getItem(SESSION_STORAGE_KEYS.sessionId));
    }
}
